var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settingModule" },
    [
      _c("label", { attrs: { for: "resultNo" } }, [
        _vm._v("Number of results"),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.settingsModule.default,
            expression: "settingsModule.default",
          },
        ],
        attrs: { type: "number", name: "resultNo", id: "resultNo" },
        domProps: { value: _vm.settingsModule.default },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.settingsModule, "default", $event.target.value)
          },
        },
      }),
      _c("br"),
      _c("em", [
        _vm._v("How many results should the widget show and load as default"),
      ]),
      _c(
        "transition",
        { attrs: { name: "slide-fade", duration: { enter: 500, leave: 0 } } },
        [
          _c(
            "div",
            [
              _c("hr"),
              _vm._l(_vm.tags, function (tagGroup, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("p", { staticClass: "tagGroupName" }, [
                      _vm._v(_vm._s(tagGroup.tagGroup)),
                    ]),
                    _vm._l(tagGroup.tags, function (tag, index) {
                      return _c("div", { key: index }, [
                        _c("label", { staticClass: "container" }, [
                          _vm._v(" " + _vm._s(tag.name) + " "),
                          _c("input", {
                            attrs: {
                              type: "radio",
                              name: "tag",
                              "data-prefix": tag.active,
                            },
                            domProps: { checked: tag.active },
                            on: {
                              click: function ($event) {
                                _vm.pickedTag = tag.tagId
                              },
                            },
                          }),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              }),
              _c("em", [_vm._v("Pick a section to show news from")]),
            ],
            2
          ),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "saveRelationsBtn",
          attrs: {
            disabled:
              _vm.settingsModule.resultNo <= 0 ||
              _vm.settingsModule.resultNo == "" ||
              this.$parent.saving ||
              (_vm.pickedTag == "" && _vm.settingsModule.mode == "articles"),
          },
          on: { click: _vm.saveSettings },
        },
        [
          _c("font-awesome-icon", {
            attrs: {
              icon: ["fas", _vm.saving ? "spinner" : "save"],
              spin: _vm.saving ? true : false,
            },
          }),
          _vm._v(" Save"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }